export default "__VITE_ASSET__46138050__"